import React from "react";
import styled, { css } from "styled-components";
import ContentEditable from "react-contenteditable";

const InputTextArea = ({
  value = "",
  onChange = () => { },
  hasError = false,
  ...rest }) => {
  return (
    <InputWrapper hasError={hasError}>
      <StyledTextArea html={value} onChange={onChange} {...rest} />
    </InputWrapper>
  );
};


const StyledTextArea = styled(ContentEditable)`
  padding: 15px;
  font-size: 1em;
  box-sizing: border-box;
  outline: 0;
  border-width: 0;
  font-family: "Open Sans", sans-serif;
  box-sizing: border-box;
  width: 100%;

  white-space: pre-wrap;

  &:empty:before {
    content: attr(data-placeholder);
    color: #888;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  border-radius: 15px;
  box-sizing: border-box;
  width: 100%;
  transition: all 100ms;
  background-color: white;

  user-select: none;

  ${(props) => {
    if (props.hasError) {
      return css`
        border: 1px solid #f44336;
        :focus-within {
          border: 1px solid #f44336;
          box-shadow: 0 0 0 1px #f44336;
        }
      `;
    } else
      return css`
        border: 1px solid #cccccc;
        :focus-within {
          /* border: 1px solid #33c494; */
          /* box-shadow: 0 0 0 1px #33c494; */
        }
      `;
  }}
`;

export default InputTextArea;
